import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Logo from '../../Logo';
import UserLink from '../../User/Link';
import Modal from '../../Popup/Modal';
import withPopupArt from '../withPopupArt';
import s from './ArtBrandedDesktopPopup.scss';
var ArtBrandedDesktopPopup = function (_a) {
    var artImageSrc = _a.artImageSrc, artAuthor = _a.artAuthor, tagline = _a.tagline, title = _a.title, leftContent = _a.leftContent, className = _a.className, taglineClassName = _a.taglineClassName, overlayClassName = _a.overlayClassName, titleClassName = _a.titleClassName, contentClassName = _a.contentClassName, onClose = _a.onClose, _b = _a.popupProps, popupProps = _b === void 0 ? {} : _b, children = _a.children;
    var t = useTranslation().t;
    return (React.createElement(Modal, __assign({ className: s['modal'], onRequestClose: onClose }, popupProps),
        React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement("div", { className: s['left'], style: { backgroundImage: artImageSrc && "url(".concat(artImageSrc, ")") } },
                React.createElement("div", { className: classnames(s['overlay'], overlayClassName) }),
                React.createElement("div", { className: s['left-content'] },
                    React.createElement(Logo, { className: s['logo'], markColor: "white", textColor: "white", size: "small" }),
                    tagline ? (React.createElement("div", { className: classnames(s['tagline'], taglineClassName) }, tagline)) : (leftContent),
                    React.createElement("div", { className: classnames(s['artist-credit'], artAuthor && s['loaded']) }, artAuthor && (React.createElement(React.Fragment, null,
                        t('common.artistCredit'),
                        React.createElement(UserLink, { user: artAuthor, className: s['user-link'] })))))),
            React.createElement("div", { className: classnames(s['right'], contentClassName) },
                title && (React.createElement("div", { className: classnames(s['title'], titleClassName) }, title)),
                children))));
};
export default withPopupArt(ArtBrandedDesktopPopup);
//# sourceMappingURL=ArtBrandedDesktopPopup.js.map